import { IntlShape } from 'react-intl';
import {
  attachmentsScopeLabelKey,
  formatTranslation,
  imageDisplayStyleLabelKey,
} from 'intl';
import { AttachmentsScope, ImageDisplayStyle } from 'shared/domain/report/types/model/common';
import { isIssueReportType } from 'shared/domain/report/types/model/reportTypeGuards';
import { SectionConfigOnView } from 'shared/domain/report/types/onView/common';

export { isIssueReportType };

export function updateDisplayStyle(
  intl: IntlShape,
  displayStyle: ImageDisplayStyle
): SectionConfigOnView['displayStyle'] {
  return {
    _id: displayStyle,
    label: formatTranslation(intl, imageDisplayStyleLabelKey(displayStyle)),
  };
}

export function buildAttachmentsScopeLabel(
  intl: IntlShape,
  scope: AttachmentsScope
): string {
  return formatTranslation(intl, attachmentsScopeLabelKey(scope));
}
